import { generateThumbnailFromGif } from '~/utils/image/getStillDataUriFromGif';
import { generateThumbnailFromVideo } from '~/composer/composer/utils/DOMUtils';
import { UppyFile } from '../uppy/UppyFile';
import { getMediaTypeFromMime } from '../utils';
import { MediaType } from '../constants';

export async function generateThumbnail(file: UppyFile): Promise<File> {
  const mediaType = getMediaTypeFromMime(file.type);
  if (mediaType === MediaType.GIF) {
    return generateThumbnailFromGif(file.data);
  }

  if (mediaType === MediaType.VIDEO) {
    return (await generateThumbnailFromVideo(file.data)).imageFile;
  }

  throw new Error(`Cannot generate thumbnail for file type: ${file.type}`);
}
